import React, {
    createContext,
    ReactElement,
    ReactNode,
    useContext, useEffect,
    useState
} from "react";
import { baseUrl } from "./typings";

type AuthContextType = {
    token: string | null;
    data?: OrgUserData;
    setToken: (token: string) => void;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

function useAuth(): AuthContextType {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}

export interface OrgUserData {
    userName: string;
    memberType: string;
    organisationName: string;
    organisationType: string;
    ownedUserLimit: number;
    maxUserLimit: number;
    addPlayersDisabled: boolean;
}

const AuthProvider = (props: { children: ReactNode }): ReactElement => {
    const [token, setTokenInner] = useState<string | null>(localStorage.getItem('hcv-sc-token'));
    const [data, setData] = useState<OrgUserData>();

    /*
    useEffect(() => {
        fetch(`${baseUrl}/authority`, {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then((res) => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject();
        })
            .then(setData)
            .catch(console.error);
    }, [token]);
    */

    const setToken = (token: string) => {
        localStorage.setItem('hcv-sc-token', token);
        setTokenInner(token);
    }

    return (
        <AuthContext.Provider value={{ token, setToken, data}}>
            {props.children}
        </AuthContext.Provider>
    );
};

export { AuthProvider, useAuth };
